<div class="atlas-autocomplete">
<p-autocomplete
  #autoComplete
  appendTo="body"
  optionLabel="AffCode"
  [autoHighlight]="true"
  [ngModel]="selectedAffCodes"
  (ngModelChange)="selectedAffCodesChanged($event)"
  (completeMethod)="searchAffCodes($event)"
  [multiple]="true"
  [suggestions]="affCodeSearchResults"
  [inputStyle]="{ width: '100%' }"
  [addOnTab]="true"
  [addOnBlur]="true"
>
  <ng-template let-item pTemplate="selectedItem">
    {{ item.AffCode }}
  </ng-template>
  <ng-template let-item pTemplate="item">
    {{ item.AffCode }}
  </ng-template>
</p-autocomplete>
</div>
